import React, {useState} from 'react'
import styles from './coperateAccountPopUpcs.module.css'
import modalcancel from "../assets/icons/modal-cancel.svg";

export default function CoperateAccountPopUp ({
    setInitialPopup,
}) {
    return (
        
             <div className={styles.popupBg}  onClick={() => setInitialPopup(false)}>
              <div className={styles.popupContainer}>
             
              <p className={styles.popupParagraph}>
              Kindly note that every information provided will be updated on our database.
              </p>
              <button
                  className={styles.popupButton}
                  onClick={() => setInitialPopup(false)}
                  >
                  proceed
                </button>
              </div>
           
        </div>
    )
}